import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4.75 3h14.5v16H4.75z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
})), 'TabletAndroidTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TabletAndroidTwoTone.js
// module id = 6683
// module chunks = 2